//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
   
      //  isMousedown:false,
       isMousedownIndex:[],    
      //  isMouseup:false,
       isMouseupIndex:[],
       roomList:[]
    };
  },
  created() {
    
  },
 mounted(){
     this.roomList=this.cloneDeepJson(this.roomBeanList)
  },
  computed:{
      moreChoose(){
         const {isMousedown,isMouseup} =this
         return{
            isMousedown,
            isMouseup
         }
      }     
  },
  watch:{
     moreChoose:{
        handler:function(newval,oldval){
               if(this.isMousedown&&this.isMouseup){
                  
                    if(this.isMousedownIndex>this.isMouseupIndex){
                       let tempt=this.isMousedownIndex;
                       this.isMousedownIndex=this.isMouseupIndex;
                       this.isMouseupIndex=tempt;
                    }
                    for(let i=this.isMousedownIndex;i<=this.isMouseupIndex;i++){
                       this.roomList[i].isSelect=true
                    }
                  //  this.isMousedown=false 
                  //   this.isMouseup=false 
                    
               }
               if(!this.isMousedown&&!this.isMouseup){
               
                   this.roomList.forEach(i=>{
                     i.isSelect=false
                  })
                           
               }
        },
        deep: true
     },
     roomBeanList:{
       handler:function(newval,oldval){
            this.roomList=this.cloneDeepJson(this.roomBeanList)
            // this.isMousedown=false
            // this.isMouseup=false
            //  console.log(this.isMousedown,this.isMouseup)
      
       },
       deep: true
     },
   //   isMousedownPro:{
   //     handler:function(newval,oldval){
   //         if(this.isMousedownPro==1){
   //             this.isMousedown=true
   //         }else if(this.isMousedownPro==0){
   //             this.isMousedown=false
   //         }
              
   //     },
   //     deep: true
   //   },
   //   isMouseupPro:{
   //     handler:function(newval,oldval){
   //        if(this.isMouseupPro==1){
   //             this.isMouseup=true
   //         }else if(this.isMouseupPro==0){
   //             this.isMouseup=false
   //         }
   //         // this.isMouseup=this.isMouseupPro    
   //     },
   //     deep: true
   //   },   
  },
  props: {
    roomBeanList: Array,
    saleStatusBeanList:Array,
    indexList:Array,
    isMousedown:Boolean,
    isMouseup:Boolean,
    isMore:Number
  },
  methods: {
         getItemBg(salesStatus,init){
       let color='#fff';
        this.saleStatusBeanList.forEach(i=>{
           if(i.number==salesStatus){
              color=i.color
           }
       })
       if(!init){
          color='#fff';
       }
       let style=''
       let bg='background-color:'+color+';';
       style=bg
        if(color=='#fff'||color=='#FFF'||color=='#FFFFFF'||color=='#ffffff'){
            let border='color:#212121;';
            if(init){
               border+='border:1px solid #ccc;box-sizing: border-box;line-height:20px;'
            }
            style=style+border
        }
       return style
    },
    cloneDeepJson(obj){
         return JSON.parse(JSON.stringify(obj))
      },
     getWidth(n,salesStatus,init,isMore){
        
        if(!n){
           n=1
        }
        let w=60*n+4*(n-1);
      //   let m=2*n;
        let wStyle='width:'+w+'px;';
        if(isMore==1){
           wStyle='width:102px;';
        }
        if(isMore==2){
           wStyle='width:138px;';
        }
        let mStyle='margin:2px 2px;';
        let style=this.getItemBg(salesStatus,init)
    
        return wStyle+mStyle+style
     },
     mousedownFn(e,n){
      
        this.roomList.forEach(i=>{
              i.isSelect=false
         })
     
        this.roomList[n].isSelect=true
     
      //   this.isMousedown=true
        this.isMousedownIndex=n
        let item={
           indexList:this.indexList,
           mousedownIndex:this.isMousedownIndex
        }
       this.$emit("mousedown",item);
     },
     mousemoveFn(e,n){
      //   console.log(this.isMousedown,this.isMouseup)
        if(this.isMousedown&&!this.isMouseup){
            this.roomList[n].isSelect=true
        }
        
      //   if(this.isMousedown&&!this.isMouseup){
           
      //       if(this.isMousedownIndex[0]==num&&this.isMousedownIndex[1]==n&&this.isMousedownIndex[2]==nn){
              
      //          this.buildList[num].floorBeanList[n].unitBeanList[nn].roomList[nnn].isSelect=true
              
      //       } 
      //   }
      // this.roomList[n].isSelect=true
      // this.dataList[n].unitList[nn].houseList[nnn].isSelect=true
     },
     mouseupFn(e,n){
   
        this.isMouseupIndex=n
        let item={
           indexList:this.indexList,
           mouseupIndex:this.isMouseupIndex
        }
        this.$emit("mouseup",item);
        if(!this.isMousedown){
           return
        }
      //   this.roomList[n].isSelect=true
      //   this.isMouseup=true
        this.isMouseupIndex=n
      //   console.log('e3',e,n,nn,nnn)
      //    this.isMouseupIndex=[num,n,nn,nnn]
      //    this.isMouseup=true
      //     if(this.isMousedownIndex[0]==this.isMouseupIndex[0]&&this.isMousedownIndex[1]==this.isMouseupIndex[1]&&this.isMousedownIndex[2]==this.isMouseupIndex[2]&&this.isMousedownIndex[3]==this.isMouseupIndex[3]){
      //       console.log('只选了一个房间，房间信息：',this.buildList[num].floorBeanList[n].unitBeanList[nn].roomList[nnn]) 
      //       return
      //     }
        
      //   this.buildList[num].floorBeanList[n].unitBeanList[nn].roomList[nnn].isSelect=true
     }
  }
};
